// extracted by mini-css-extract-plugin
export default {"DocumentDropzone":"DocumentDropzone_DocumentDropzone__KTnz3","fluid":"DocumentDropzone_fluid__WEBOh","active":"DocumentDropzone_active__Pk6Yj"};